import React from 'react'

// Общая карточка публичных экранов авторизации: вход, восстановление, страницы
// по ссылкам из писем. Логотип и рамка одни и те же, поэтому вынесены.
export default function AuthCard ({ children }) {
  return (
    <div style={s.page}>
      <div style={s.card}>
        <a
          href='https://fintablo.ru/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Перейти на сайт Финтабло'
          style={s.brand}
        >
          <img
            src='/fintablo-platform-logo.png'
            alt='Финтабло — платформа интеграций'
            style={s.brandLogo}
          />
        </a>
        {children}
      </div>
    </div>
  )
}

export const authCardStyles = {
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 500, color: '#374151' },
  error: { padding: '10px 14px', borderRadius: 8, background: '#FEF2F2', color: '#DC2626', fontSize: 13 },
  notice: { padding: '10px 14px', borderRadius: 8, background: '#F0FDF4', color: '#15803D', fontSize: 13 },
  tabs: { display: 'flex', borderBottom: '1px solid #E2E8F0', marginBottom: 24 },
  tab: { flex: 1, padding: '8px 0', background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 14, color: '#64748B', cursor: 'pointer', fontWeight: 500 },
  tabActive: { color: '#0E4D72', borderBottom: '2px solid #0E4D72', marginBottom: -1 },
  stepTitle: { fontSize: 15, fontWeight: 600, color: '#0F172A' },
  hint: { fontSize: 12, lineHeight: 1.45, color: '#64748B' },
  link: { alignSelf: 'center', padding: 0, background: 'none', border: 'none', color: '#0E4D72', fontFamily: 'inherit', fontSize: 13, fontWeight: 500, cursor: 'pointer', textDecoration: 'none' },
  // Галочка согласия: подпись со ссылкой и звёздочкой обязательности, как в
  // форме регистрации fintablo.ru.
  consentRow: { display: 'grid', gridTemplateColumns: '18px 1fr', gap: 10, alignItems: 'start', fontSize: 13, lineHeight: 1.45, color: '#374151', cursor: 'pointer' },
  consentBox: { width: 18, height: 18, margin: '1px 0 0', accentColor: '#5269b8', cursor: 'pointer' },
  consentLink: { color: '#5269b8', textDecoration: 'underline', textUnderlineOffset: 2 },
  required: { color: '#b42318', fontWeight: 700 },
  who: { fontSize: 12, color: '#64748B', textAlign: 'center' }
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F1F5F9' },
  card: { background: '#fff', borderRadius: 16, padding: '40px 36px', width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  brand: { display: 'block', margin: '0 auto 28px', maxWidth: 300 },
  brandLogo: { display: 'block', height: 'auto', width: '100%' }
}
